import { Box, Container, Grid2, Paper, Typography } from '@mui/material';
import React from 'react';


const services = [
    {
      title: 'Construção de Casas',
      description:
        'Projetos personalizados e execução detalhada para transformar sua ideia em realidade. Qualidade e segurança garantidas.',
    },
    {
      title: 'Reformas Gerais',
      description:
        'Renove e modernize seu espaço com serviços completos de reforma, desde pequenos reparos até grandes transformações.',
    },
    {
      title: 'Instalação de Pisos',
      description:
        'Instalação profissional de pisos para garantir um acabamento perfeito e duradouro em qualquer ambiente.',
    },
    {
      title: 'Encanamento',
      description:
        'Soluções completas em encanamento, desde instalações até reparos, sempre com eficiência e confiabilidade.',
    },
    {
      title: 'Pintura Interna e Externa',
      description:
        'Renove sua casa ou comércio com pintura de alta qualidade, proporcionando beleza e proteção.',
    },
    
  ];
  

const Services = () => (
  <Box
    id="services"
    sx={{
      py: 6,
      px: { xs: 2, sm: 4, md: 8 },
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      textAlign: 'flex-start',
      marginBottom: 10
    }}
  >
    <Container maxWidth={ "lg"}>
      <Typography
        variant="h4"
        sx={{
          fontWeight: 'bold',
          marginBottom: 4,
          color: '#1A7B30',
        }}
      >
        Serviços Oferecidos
      </Typography>
      <Grid2 container spacing={2} justifyContent="center">
        {services.map((service, index) => (
          <Grid2 xs={12} sm={6} md={8} key={index} gap={2} >
            <Paper
              elevation={3}
              sx={{
                padding: 3,
                borderRadius: 2,
                textAlign: 'center',
                height: 200,
                maxWidth: 200,
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center',
              }}
            >
              <Typography  variant="h6" sx={{ fontWeight: 'bold', marginBottom: 1 }}>
                {service.title}
              </Typography>
              <Typography variant="body2" color="text.secondary">
              {service.description}
              </Typography>
            </Paper>
          </Grid2>
        ))}
      </Grid2>
    </Container>
  </Box>
);

export default Services;